module.exports = __webpack_public_path__ + "img/service-icon3.7edbbb43.png";